import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
	name: "cellphoneNumber",
	standalone: true
})
export class CellphoneNumberPipe implements PipeTransform {
	transform(unformattedCellphoneNumber: string): string {
		const regularExpression = new RegExp(/(\d{2})(\d{4,5})(\d{4})/);
		const mask = "($1) $2-$3";
		return unformattedCellphoneNumber.replace(regularExpression, mask);
	}
}
